import React, { Component } from 'react';
import { Col, Row, Button,Container } from 'react-bootstrap';
import PreloaderTwo from '../preloader/PreloaderTwo';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from 'moment';
import ParentNotificationModal from './ParentNotificationModal';
import LongDiscriptionModal from './LongDiscriptionModal';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';

const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        globalBranches{
            id
            branch_name
        }
          classes{
            id
            class
          }
          exams{
            id
            exam
          }
          globalSections{
            id
            section_name
          }
          b_e_c_s_data{
            branch_id
            exam_id
            class_id
            section_id
          }
          educationalClasses{
            id
            class
          }
    }
}

`;
const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        exam_id
        exam_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`
const GET_PARENTS_CUSTOM_NOTIFICATION = gql`
query($institution_id:Int $branch_ids: String){
    getParentsCustomNotification(institution_id: $institution_id, branch_ids: $branch_ids) {
        title
        branch_ids
        section_ids
        notification_sent_timestamp
        exam_ids
        class_ids
        long_description
      }
}
`

class ParentNotificationSection extends Component {
    constructor(){
        super();
        this.state = {
            modalShow: false,
            viewDetailModal: false,
            selectedDiscription:""
        }
    }
    sendNotifyBtn = () =>{
        this.setState({
            modalShow: true
        })
    }
    articlecolumns = [
        {
            dataField: "title",
            text: "Title",
            sort: true
        },
        {
            dataField: "date",
            text: "Date",
            sort: true
        },
        {
            dataField: "time",
            text: "Time",
            sort: true
        },
        {
            dataField: "branch",
            text: "Branch",
            sort: true
        },
        {
            dataField: "class",
            text: "Class",
            sort: true
        },
        {
            dataField: "exam",
            text: "Exam",
            sort: true
        },
        {
            dataField: "section",
            text: "Section",
            sort: true
        },
        {
            dataField: "View Details",
            formatter: this.performanceFunc.bind(this),
            text: "View Details"
          },
    ];

    tableUserData() {
        let notifyParent = this.props.getParentsCustomNotification.getParentsCustomNotification
        const newArray = [];
       

        notifyParent.map((mapdata) => {

            let getDataclass = [];
            if (mapdata.class_ids != "") {

                let className = mapdata.class_ids.split(",");
                className.map((item) => {
                    let findclass = this.props.globals.globals.classes.find((a) => a.id == item);
                    if (findclass != undefined) {
                        getDataclass.push(findclass.class);
                    }

                })

            }
            let getData = [];
            if (mapdata.branch_ids != "") {

                let branch = mapdata.branch_ids.split(",");
                branch.map((item) => {
                    let findbranch = this.props.globals.globals.globalBranches.find((a) => a.id == item);
                    if (findbranch != undefined) {
                        getData.push(findbranch.branch_name);
                    }

                })

            }

            let getDatasection = [];
            if (mapdata.section_ids != "") {

                let section = mapdata.section_ids.split(",");
                section.map((item) => {
                    let findsection = this.props.globals.globals.globalSections.find((a) => a.id == item);
                    if (findsection != undefined) {
                        getDatasection.push(findsection.section_name);
                    }

                })

            }

            let getDataExam = [];
            if (mapdata.exam_ids != "") {

                let exam = mapdata.exam_ids.split(",");
                exam.map((item) => {
                    let findexam = this.props.globals.globals.exams.find((a) => a.id == item);
                    if (findexam != undefined) {
                        getDataExam.push(findexam.exam);
                    }

                })

            }
            const newObj = {
                branch_ids: mapdata.branch_ids,
                exam_ids: mapdata.exam_ids,
                class_ids: mapdata.class_ids,
                section_ids: mapdata.section_ids,
                branch: getData.toString(),
                exam: getDataExam.toString(),
                class: getDataclass.toString(),
                section: getDatasection.toString(),
                title: mapdata.title,
                longdiscription: mapdata.long_description,
                date: moment.unix(mapdata.notification_sent_timestamp).format("DD/MM/YYYY"),
                time: moment.unix(mapdata.notification_sent_timestamp).format("LT")
            }
            newArray.push(newObj);
           
        })
        return newArray;

    }
    performanceFunc(val, row) {
        console.log("rowwwwwwwwwww", row)
        return (<>
          <div className="actions-buttons d-flex justify-content-center align-items-top" >
            <Button variant="link" name="edit" className="text-theme" onClick={() => this.setState({viewDetailModal: true, selectedDiscription: row.longdiscription})}>
              <i className="far fa-edit" />
            </Button>
          </div>
        </>)
      }
    render() {
        console.log("st", this.state);
        const globals = this.props.globals;
        console.log("globals", globals);
        const loading1 = globals.loading;
        const error1 = globals.error;


        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        const getNewEducationalStudents = this.props.getNewEducationalStudents;
        const loading2 = getNewEducationalStudents.loading;
        const error2 = getNewEducationalStudents.error
         console.log("getNewEducationalStudents", getNewEducationalStudents);

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        const getParentsCustomNotification = this.props.getParentsCustomNotification;
        const loading3= getParentsCustomNotification.loading;
        const error3 = getParentsCustomNotification.error
         console.log("getParentsCustomNotification", getParentsCustomNotification);
        if (error3 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        return (
            <React.Fragment>
                {
                    loading1 || loading2 || loading3 ?
                    (
                        <Container>
                            <Row className="my-2">
                                <Col>
                                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                                </Col>
                            </Row>
                        </Container>
                    ) :(
                        <div className="user-creation">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-3 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0 text-uppercase">Notify Students</h2>
                              {this.state.modalShow == false ? <button className="btn px-4" style={{backgroundColor:"#213046",color:"#fff",fontSize:"12px",padding:"7px"}} onClick={this.sendNotifyBtn}>Send Notification</button> :("")}
                            </div>
                            {this.state.modalShow == true ?
                            <ParentNotificationModal
                            stateData={this.state}
                             show={this.state.modalShow}
                             onHide={() => this.setState({ modalShow: false })}
                             globals = {globals.globals}
                             getNewEducationalStudents = {getNewEducationalStudents.getNewEducationalStudents}
                            /> :("")}
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} >
                            <h6 className='text-center mt-3'>Notification Table</h6>
                            <CardLessDataTableWithOutSearch
                                parentData={this.tableUserData(getParentsCustomNotification.getParentsCustomNotification)}
                                particlecolumns={this.articlecolumns}
                            />
                            <LongDiscriptionModal
                             stateData={this.state}
                             show={this.state.viewDetailModal}
                             onHide={() => this.setState({ viewDetailModal: false })}
                            />
                        </Col>
                    </Row>
                </div>
                    )
                }
            </React.Fragment>
            
        )
    }
}
export default compose(
    graphql(FETCH_GLOBALS,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                }
            }), name: "globals"
        }),
        graphql(GET_STUDENT_DETAILS, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "getNewEducationalStudents",
        }),
        graphql(GET_PARENTS_CUSTOM_NOTIFICATION, {
            options: (props) => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                    branch_ids: Cookies.get("branch_id").toString()
                },
            }),
            name: "getParentsCustomNotification",
        })
)
    (ParentNotificationSection);